export default "__VITE_ASSET__DvOCn6mT__"